import { ComponentsProps } from "@mui/material";

interface ILink {
  defaultProps: ComponentsProps["MuiLink"];
}

const link: ILink = {
  defaultProps: {
    underline: "none",
    color: "inherit",
  },
};

export default link;
